import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import React from 'react';
import completedIcon from './assets/icon_completed.svg';
import styles from './index.module.scss';

export type SkillCheckTestButtonProps = {
  userAttendanceSlug: string;
  disabled: boolean;
  completed: boolean;
  onClick?: () => void;
};

export const SkillCheckTestButton = ({
  userAttendanceSlug,
  disabled,
  completed,
  onClick,
}: SkillCheckTestButtonProps) => {
  const skillCheckTestTo = completed
    ? '/user-attendances/$userAttendanceSlug/skill-check-test/result'
    : '/user-attendances/$userAttendanceSlug/skill-check-test';
  const searchParams = completed ? { timeUp: false } : { retry: false };

  return (
    <Link
      to={skillCheckTestTo}
      params={{
        userAttendanceSlug: userAttendanceSlug,
      }}
      search={searchParams}
      className={classNames(styles.skillCheckTestButton, {
        [styles.disabled]: disabled,
        primaryShadow: !disabled,
      })}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={styles.skillCheckTestButtonInner}>
        <svg
          className={styles.icon}
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Skill Check Test Icon</title>
          <path
            d="M7.36673 22.0667L12.1001 17.3334C12.3667 17.0667 12.6778 16.9389 13.0334 16.95C13.389 16.9612 13.7001 17.1 13.9667 17.3667C14.2112 17.6334 14.3334 17.9445 14.3334 18.3C14.3334 18.6556 14.2112 18.9667 13.9667 19.2334L8.3334 24.9C8.06673 25.1667 7.75562 25.3001 7.40007 25.3001C7.04451 25.3001 6.7334 25.1667 6.46673 24.9L3.60007 22.0334C3.35562 21.7889 3.2334 21.4778 3.2334 21.1C3.2334 20.7223 3.35562 20.4112 3.60007 20.1667C3.84451 19.9223 4.15562 19.8 4.5334 19.8C4.91118 19.8 5.22229 19.9223 5.46673 20.1667L7.36673 22.0667ZM7.36673 11.4L12.1001 6.66671C12.3667 6.40005 12.6778 6.27227 13.0334 6.28338C13.389 6.29449 13.7001 6.43338 13.9667 6.70005C14.2112 6.96671 14.3334 7.27783 14.3334 7.63338C14.3334 7.98894 14.2112 8.30005 13.9667 8.56671L8.3334 14.2334C8.06673 14.5 7.75562 14.6334 7.40007 14.6334C7.04451 14.6334 6.7334 14.5 6.46673 14.2334L3.60007 11.3667C3.35562 11.1223 3.2334 10.8112 3.2334 10.4334C3.2334 10.0556 3.35562 9.74449 3.60007 9.50005C3.84451 9.2556 4.15562 9.13338 4.5334 9.13338C4.91118 9.13338 5.22229 9.2556 5.46673 9.50005L7.36673 11.4ZM18.6667 23.1667C18.289 23.1667 17.9723 23.0389 17.7167 22.7834C17.4612 22.5278 17.3334 22.2112 17.3334 21.8334C17.3334 21.4556 17.4612 21.1389 17.7167 20.8834C17.9723 20.6278 18.289 20.5 18.6667 20.5H28.0001C28.3778 20.5 28.6945 20.6278 28.9501 20.8834C29.2056 21.1389 29.3334 21.4556 29.3334 21.8334C29.3334 22.2112 29.2056 22.5278 28.9501 22.7834C28.6945 23.0389 28.3778 23.1667 28.0001 23.1667H18.6667ZM18.6667 12.5C18.289 12.5 17.9723 12.3723 17.7167 12.1167C17.4612 11.8612 17.3334 11.5445 17.3334 11.1667C17.3334 10.7889 17.4612 10.4723 17.7167 10.2167C17.9723 9.96116 18.289 9.83338 18.6667 9.83338H28.0001C28.3778 9.83338 28.6945 9.96116 28.9501 10.2167C29.2056 10.4723 29.3334 10.7889 29.3334 11.1667C29.3334 11.5445 29.2056 11.8612 28.9501 12.1167C28.6945 12.3723 28.3778 12.5 28.0001 12.5H18.6667Z"
            fill="currentColor"
          />
        </svg>

        <span>スキルチェックテスト</span>
      </div>

      {completed && (
        <img
          className={styles.completedIcon}
          src={completedIcon}
          alt="Completed lesson"
        />
      )}
    </Link>
  );
};
